// extracted by mini-css-extract-plugin
export default {"icon":"_0da00fc4c588000a","infoWrapper":"_01c950bb5e4d9915"};